<template>
    <div class="form-field form-field__input form-field__hidden" :class="[rootClasses]">
        <input type="hidden" v-bind="inputBindings">
    </div>
</template>

<script>
    import formFieldAbstractMixin from 'framework/mixins/form/form-field-abstract';


    export default {
        mixins: [
            formFieldAbstractMixin,
        ],
        props: {
            type: {
                type: String,
                default: 'hidden',
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/form/form-field-hidden/index.vue?065210d7